export class InstallGuideModal {
  private root: HTMLElement;
  private isOpen = false;
  private onKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') this.close();
  };

  constructor(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className =
      'fixed inset-0 z-[70] hidden items-center justify-center bg-wood-coffee/75 backdrop-blur-sm p-4';
    this.root.setAttribute('role', 'dialog');
    this.root.setAttribute('aria-modal', 'true');
    this.root.setAttribute('aria-label', '홈 화면에 추가');
    parent.appendChild(this.root);
  }

  mount(): void {
    this.render();
    this.root.addEventListener('click', (e) => {
      if (e.target === this.root) this.close();
    });
  }

  unmount(): void {
    document.removeEventListener('keydown', this.onKeyDown);
    this.root.remove();
  }

  open(): void {
    if (this.isOpen) return;
    this.isOpen = true;
    this.root.classList.remove('hidden');
    this.root.classList.add('flex');
    document.addEventListener('keydown', this.onKeyDown);
  }

  close(): void {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.root.classList.add('hidden');
    this.root.classList.remove('flex');
    document.removeEventListener('keydown', this.onKeyDown);
  }

  private render(): void {
    this.root.innerHTML = `
      <div class="flex flex-col gap-4 rounded-2xl bg-wood-paper ring-1 ring-wood-sand p-6 max-w-md w-full shadow-xl max-h-[85dvh] overflow-y-auto">
        <div class="flex items-start justify-between gap-3">
          <h2 class="text-xl font-extrabold tracking-tight text-wood-ink">홈 화면에 추가</h2>
          <button
            type="button"
            data-role="close"
            aria-label="닫기"
            class="rounded-lg p-1 text-wood-coffee/70 hover:text-wood-ink hover:bg-wood-cream ring-1 ring-transparent hover:ring-wood-sand"
          >
            ✕
          </button>
        </div>
        <p class="text-sm text-wood-coffee leading-relaxed">
          Safari에서 아래 단계를 따라 Completto를 앱처럼 설치할 수 있어요.
        </p>
        <ol class="flex flex-col gap-3 text-sm text-wood-coffee">
          <li class="flex items-start gap-3">
            <span class="shrink-0 inline-flex w-6 h-6 items-center justify-center rounded-full bg-card-navy text-card-gold text-xs font-bold">1</span>
            <span class="leading-relaxed">하단(또는 상단) 도구 막대의 <span class="font-semibold text-card-brass">공유</span> 버튼을 눌러주세요. <span class="ml-1 inline-block">⬆️</span></span>
          </li>
          <li class="flex items-start gap-3">
            <span class="shrink-0 inline-flex w-6 h-6 items-center justify-center rounded-full bg-card-navy text-card-gold text-xs font-bold">2</span>
            <span class="leading-relaxed">메뉴를 아래로 스크롤해 <span class="font-semibold text-card-brass">홈 화면에 추가</span>를 선택하세요.</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="shrink-0 inline-flex w-6 h-6 items-center justify-center rounded-full bg-card-navy text-card-gold text-xs font-bold">3</span>
            <span class="leading-relaxed">우측 상단 <span class="font-semibold text-card-brass">추가</span>를 누르면 끝!</span>
          </li>
        </ol>
        <p class="text-xs text-wood-coffee/65 leading-relaxed">
          홈 화면 아이콘으로 실행하면 풀스크린으로 더 쾌적하게 플레이할 수 있어요.
        </p>
        <button
          type="button"
          data-role="close"
          class="mt-2 rounded-xl bg-wood-bark hover:bg-wood-coffee text-wood-paper py-2 text-sm font-medium"
        >
          알겠어요
        </button>
      </div>
    `;
    for (const btn of this.root.querySelectorAll<HTMLButtonElement>('[data-role="close"]')) {
      btn.addEventListener('click', () => this.close());
    }
  }
}
